import { render, staticRenderFns } from "./TimeSpanText.vue?vue&type=template&id=8ac72822"
import script from "./TimeSpanText.vue?vue&type=script&lang=ts"
export * from "./TimeSpanText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports